module.exports = __webpack_public_path__ + "static/media/alum_vert_slid.4b46f380.png";